import {
  DEFAULT_IMAGE_SIZE_TRANSFER,
  DEFAULT_FILE_SIZE_TRANSFER,
  DEFAULT_VIDEO_SIZE_TRANSFER,
  MAX_IMAGE_SIZE_TRANSFER,
  MAX_FILE_SIZE_TRANSFER,
  MAX_IMAGE_SIZE_TRANSFER_WS,
  MAX_FILE_SIZE_TRANSFER_MSN_IG,
  MAX_VIDEO_SIZE_TRANSFER
} from '../constants/chatFileSizes';

const isDefaultImageSize = (file) => file.size <= DEFAULT_IMAGE_SIZE_TRANSFER;

const isDefaultVideoSize = (file) => file.size <= DEFAULT_VIDEO_SIZE_TRANSFER;

const isDefaultFileSize = (file) => file.size <= DEFAULT_FILE_SIZE_TRANSFER;

const isMaxImageSize = (file) => file.size <= MAX_IMAGE_SIZE_TRANSFER;

const isMaxVideoSize = (file) => file.size <= MAX_VIDEO_SIZE_TRANSFER;

const isMaxFileSize = (file) => file.size <= MAX_FILE_SIZE_TRANSFER;

const isValidImageSizeForWs = (file) => file.size <= MAX_IMAGE_SIZE_TRANSFER_WS;

const isValidFileSizeForMsnOrIg = (file) => file.size <= MAX_FILE_SIZE_TRANSFER_MSN_IG;

const sizeFileInMB = (size) => size / (1024 * 1024);

const buildFormData = (formData, data, parentKey) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    if (data instanceof Array) {
      data.forEach((el) => {
        buildFormData(formData, el, parentKey ? `${parentKey}[]` : el);
      });
    } else {
      Object.keys(data).forEach((key) => {
        buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    }
  } else {
    const value = data == null ? '' : data;

    formData.append(parentKey, value);
  }
};

const objectToFormData = (data) => {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
};

// eslint-disable-next-line default-param-last
const formatFileSize = (bytes = 0, decimalPoint = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1000;
  const dm = decimalPoint;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

const isValidVideoSizeForWs = () => true;

const acceptedImageTypes = {
  'image/jpg': ['.jpeg', '.jpg'],
  'image/png': ['.png']
};

export default {
  isDefaultImageSize,
  isDefaultVideoSize,
  isDefaultFileSize,
  isMaxImageSize,
  isMaxFileSize,
  isValidImageSizeForWs,
  isMaxVideoSize,
  isValidFileSizeForMsnOrIg,
  sizeFileInMB,
  objectToFormData,
  formatFileSize,
  isValidVideoSizeForWs,
  acceptedImageTypes
};
